
// project imports
import MainLayout from '../components/layout';
import AuthGuard from '../utils/AuthGuard';
import HomePage from '../views/home';
import CardDetailPage from '../views/cardDetail';

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: '/Home',
      element: <HomePage />
    },
    {
      path: '/CardDetailPage',
      element: <CardDetailPage />
    },
  ]
};

export default MainRoutes;